import React, { FC, useEffect, useState } from "react";
import { Aligment, Button, Loader, TextSmall } from "venice-ui";
import {
  ErrorArea,
  LoginActionLink,
  LoginFooterSection,
  LoginFormSection,
  LoginTite,
} from "./Login.styles";
import { errorMsg, LOGIN_MODE, TLoginMode } from "../../helpers/loginHelper";
import { apiCall } from "../../untils/apiCall";
import { createUserWithEmailAndPassword, getAuth } from "firebase/auth";
import {
  checkLang,
  createUser,
  getLang,
  joinUser,
  t,
} from "../../helpers/userHelper";
import {
  RegisterEmail,
  RegisterPassword,
  RegisterVerificationCode,
} from "./Partial";
import {
  checkCompanyDetails,
  checkStatus,
  emailFormatCheck,
} from "../PasswordCheck/checks";
import { dictionary } from "../../untils/dictionary";
import { useNavigate, useParams } from "react-router-dom";
import { IPracingProps } from "./register.types";
import { RegisterPlan } from "./Partial/RegisterPlan";
import { RegisterPaymentDetails } from "./Partial/RegisterPaymentDetails";
import { LoaderContainer } from "../publicComponents";
import { preprePricing } from "../../helpers/organizationHelper";
import { setCountryMode } from "../../helpers/countryHelpers";

interface IRegisterFormProps {
  changeMode: (mode: TLoginMode) => void;
}

interface ICreateUserProps {
  login: string;
  password: string;
  verifyCode: string;
  codeID: string;
  loading: boolean;
  error: boolean;
  errorCode: string;
  step: number;
  probe: number;
  orgPlanID: string;
  orgPlanName: string;
  orgPriceID: string;
  companyName: string;
  companyAdressLine1: string;
  companyPostCode: string;
  companyCity: string;
  companyCountry: string;
  companyNip: number | undefined;
  acceptTerms: boolean;
  emailSubscription: boolean;
  extraTaxNumerber: string;
  isCompany: boolean;
  isWaiverOfTheRightToWithdraw: boolean;
}

export const RegisterForm: FC<IRegisterFormProps> = ({ changeMode }) => {
  const { pageMode, code } = useParams();
  const navigate = useNavigate();
  const [pricePlans, setPricePlans] = useState<IPracingProps[]>([]);
  const [loading, setLoading] = useState(false);

  const isJoinMode = pageMode !== undefined && pageMode === "join";

  const getPricing = async (user?: string) => {
    const options = { user: user };

    await apiCall("payments/getPricing", options, (response: any) => {
      if (response.error) {
        navigate("/server-error");
      }
      setPricePlans(preprePricing(response.pricing));
    });
  };

  const [sectionData, updateSectionData] = useState<ICreateUserProps>({
    login: "",
    password: "",
    verifyCode: "",
    codeID: "",
    loading: false,
    error: false,
    errorCode: "",
    step: 0,
    probe: 0,
    orgPlanID: "",
    orgPlanName: "",
    orgPriceID: "",
    companyName: "",
    companyAdressLine1: "",
    companyPostCode: "",
    companyCity: "",
    companyCountry: "",
    companyNip: undefined,
    extraTaxNumerber: "",
    acceptTerms: false,
    emailSubscription: false,
    isCompany: true,
    isWaiverOfTheRightToWithdraw: false,
  });

  useEffect(() => {
    getPricing(sectionData.login);
  }, [sectionData.login]);

  const clearBilingDetails = () => {
    updateSectionData({
      ...sectionData,
      companyName: "",
      companyAdressLine1: "",
      companyPostCode: "",
      companyCity: "",
      companyNip: undefined,
    });
  };
  const setValue = (field: string, value: string) => {
    if (field === "login") {
      updateSectionData({
        ...sectionData,
        [field]: value,
      });
    } else {
      updateSectionData({
        ...sectionData,
        [field]: value,
      });
    }
  };

  const setToogleValue = (field: string, value: boolean) => {
    updateSectionData({
      ...sectionData,
      [field]: value,
    });
  };
  const verifyEmailAddress = async () => {
    if (sectionData.login.length > 0) {
      if (emailFormatCheck(sectionData.login)) {
        const options = {
          email: sectionData.login.trim(),
          invitationID: code,
          lang: checkLang(),
        };

        await apiCall("user/setVeryfiCode", options, (response: any) => {
          if (response.data.error) {
            updateSectionData({
              ...sectionData,
              error: true,
              errorCode: response.data.errorMsg,
              loading: false,
            });
          } else {
            updateSectionData({
              ...sectionData,
              error: false,
              errorCode: "",
              loading: false,
              codeID: response.data.codeID,
              verifyCode: "",
              step: 1,
              probe: 0,
            });
          }
        });
      } else {
        updateSectionData({
          ...sectionData,
          error: true,
          errorCode: "wrong-email",
          loading: false,
        });
      }
    }
  };
  const verifyCode = async () => {
    const options = {
      codeID: sectionData.codeID,
      code: sectionData.verifyCode,
    };
    await apiCall("user/checkVeryfiCode", options, (response: any) => {
      if (response.check) {
        updateSectionData({
          ...sectionData,
          error: false,
          errorCode: "",
          loading: false,
          step: 2,
          probe: 0,
        });
      } else {
        updateSectionData({
          ...sectionData,
          error: true,
          errorCode: "wrong-code",
          loading: false,
          probe: sectionData.probe + 1,
        });
      }
    });
  };

  const auth = getAuth();
  const registerUser = async () => {
    let checker = true;
    if (checker) {
      sessionStorage.setItem("paymentFlow", "true");
      setLoading(true);
      await createUserWithEmailAndPassword(
        auth,
        sectionData.login,
        sectionData.password,
      )
        .then(async (userCredential) => {
          if (isJoinMode) {
            await joinUser(
              sectionData.login,
              userCredential.user.uid,
              code !== undefined ? code : "",
              sectionData.acceptTerms,
              sectionData.emailSubscription,
            );
          } else {
            setLoading(false);
            const NIP = sectionData.companyNip || "";
            await createUser(
              sectionData.login,
              userCredential.user.uid,
              sectionData.orgPlanID,
              sectionData.companyName.trim(),
              sectionData.companyAdressLine1,
              sectionData.companyPostCode,
              sectionData.companyCity,
              sectionData.companyCountry,
              NIP.toString(),
              sectionData.acceptTerms,
              sectionData.emailSubscription,
              checkLang() || "pl",
              sectionData.orgPlanName,
              sectionData.orgPriceID,
              sectionData.extraTaxNumerber,
              sectionData.isCompany,
              sectionData.isWaiverOfTheRightToWithdraw,
              setCountryMode(sectionData.companyCountry),
            );
            setLoading(false);
          }
        })
        .catch((error: Error) => {
          console.log(error);
        });
    }
  };

  const goToSelectPlan = () => {
    updateSectionData({
      ...sectionData,
      step: 3,
    });
  };
  const goToComapnyDetails = () => {
    updateSectionData({
      ...sectionData,
      companyName: "",
      companyAdressLine1: "",
      companyPostCode: "",
      companyCity: "",
      companyCountry: "",
      companyNip: undefined,
      extraTaxNumerber: "",
      isCompany: true,
      isWaiverOfTheRightToWithdraw: false,
      step: 4,
    });
  };

  const selectUserPlan = (
    planID: string,
    planName: string,
    priceID: string,
  ) => {
    updateSectionData({
      ...sectionData,
      orgPlanID: planID,
      orgPlanName: planName,
      orgPriceID: priceID,
    });
  };

  const nextAction = async () => {
    if (!sectionData.loading) {
      updateSectionData({
        ...sectionData,
        error: false,
        errorCode: "",
        loading: true,
      });
      if (sectionData.step === 0) {
        verifyEmailAddress();
      } else if (sectionData.step === 1) {
        verifyCode();
      } else if (sectionData.step === 2) {
        isJoinMode ? registerUser() : goToSelectPlan();
      } else if (sectionData.step === 3) {
        goToComapnyDetails();
      } else if (sectionData.step === 4) {
        registerUser();
      }
    }
  };
  const setButtonText = (): string => {
    if (sectionData.step === 0) {
      return t(dictionary.next);
    } else if (sectionData.step === 1) {
      return t(dictionary.verify);
    } else if (sectionData.step === 2) {
      return isJoinMode ? t(dictionary.createAnAccount) : t(dictionary.next);
    } else if (sectionData.step === 3) {
      return t(dictionary.next);
    } else if (sectionData.step === 4) {
      return t(dictionary.createAnAccount);
    }
    return t(dictionary.next);
  };

  const checkDisable = () => {
    let status = false;
    if (sectionData.step === 0) {
      status = sectionData.login === "" || !sectionData.acceptTerms;
    } else if (sectionData.step === 2) {
      status = checkStatus(sectionData.password);
    } else if (sectionData.step === 3) {
      status = sectionData.orgPlanID === "";
    } else if (sectionData.step === 4) {
      status = checkCompanyDetails(
        sectionData.companyName,
        sectionData.companyAdressLine1,
        sectionData.companyPostCode,
        sectionData.companyCity,
        sectionData.companyCountry,
        sectionData.isCompany,
        sectionData.isWaiverOfTheRightToWithdraw,
        sectionData.extraTaxNumerber,
        sectionData.companyNip,
      );
    }
    return status;
  };

  if (loading) {
    return (
      <LoaderContainer>
        <Loader size="medium" />
      </LoaderContainer>
    );
  }
  return (
    <Aligment justify="center" direction="column">
      <LoginTite>{t(dictionary.registerTitle)}</LoginTite>

      {sectionData.step === 0 && (
        <RegisterEmail
          termsValue={sectionData.acceptTerms}
          emailSubscriptionValue={sectionData.emailSubscription}
          loginValue={sectionData.login}
          handleChange={(name, value) => setValue(name, value as string)}
          handleToogle={setToogleValue}
          handleSubmit={verifyEmailAddress}
        />
      )}
      {sectionData.step === 1 && (
        <RegisterVerificationCode
          inputValue={sectionData.verifyCode}
          handleChange={(name, value) => setValue(name, value as string)}
          handleSubmit={verifyCode}
        />
      )}
      {sectionData.step === 2 && (
        <RegisterPassword
          inputValue={sectionData.password}
          handleChange={(name, value) => setValue(name, value as string)}
          handleSubmit={isJoinMode ? registerUser : goToSelectPlan}
        />
      )}
      {sectionData.step === 3 && (
        <RegisterPlan
          plans={pricePlans}
          activePlan={sectionData.orgPlanID}
          handleSelect={selectUserPlan}
        />
      )}
      {sectionData.step === 4 && (
        <RegisterPaymentDetails
          companyName={sectionData.companyName}
          companyAdressLine1={sectionData.companyAdressLine1}
          companyPostCode={sectionData.companyPostCode}
          companyCity={sectionData.companyCity}
          companyCountry={sectionData.companyCountry}
          companyNip={sectionData.companyNip}
          extraTaxNumerber={sectionData.extraTaxNumerber}
          isCompany={sectionData.isCompany}
          isWaiverOfTheRightToWithdraw={
            sectionData.isWaiverOfTheRightToWithdraw
          }
          handleChange={(name, value) => setValue(name, value as string)}
          clearDetails={() => clearBilingDetails()}
          handleToogle={(name: string, value: boolean) =>
            setToogleValue(name, value)
          }
          pricePlanID={sectionData.orgPlanID}
        />
      )}
      {
        <>
          {sectionData.error && (
            <LoginFormSection>
              <ErrorArea>{errorMsg(sectionData.errorCode)}</ErrorArea>
            </LoginFormSection>
          )}
          {sectionData.probe === 2 ? (
            <LoginActionLink onClick={() => verifyEmailAddress()}>
              {t(dictionary.sendCodeAgain)}
            </LoginActionLink>
          ) : (
            <Aligment align="center" justify="center" gap={8}>
              {sectionData.step === 4 && (
                <Button
                  text={t(dictionary.back)}
                  onClick={goToSelectPlan}
                  mode="secondary"
                />
              )}
              <Button
                text={setButtonText()}
                onClick={nextAction}
                loader={sectionData.loading}
                disabled={checkDisable()}
              />
            </Aligment>
          )}
        </>
      }
      <LoginFooterSection>
        <TextSmall>
          {t(dictionary.doYouHaveAccount)}
          <LoginActionLink onClick={() => changeMode(LOGIN_MODE.login)}>
            {t(dictionary.loginAccount)}
          </LoginActionLink>
        </TextSmall>
      </LoginFooterSection>
    </Aligment>
  );
};
